"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useAccordionHeaderContextValues_unstable", {
    enumerable: true,
    get: function() {
        return useAccordionHeaderContextValues_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
function useAccordionHeaderContextValues_unstable(state) {
    const { disabled, expandIconPosition, open, size } = state;
    const accordionHeader = _react.useMemo(()=>({
            disabled,
            expandIconPosition,
            open,
            size
        }), [
        disabled,
        expandIconPosition,
        open,
        size
    ]);
    return {
        accordionHeader
    };
}
